import React from 'react'
import { downloadAttachment } from '../../../../utils/fileDownloadUtils'
import { Button } from 'reactstrap'

const AttachmentList = ({ attachments = [], size = 'md' }) => {
  return (
    <div className='d-flex align-items-start flex-wrap justify-content-between'>
      {attachments.length > 0 &&
        attachments.map((attachment) => {
          const icon = attachment.type.includes('pdf')
            ? 'fa-file-pdf'
            : attachment.type.includes('image')
            ? 'fa-file-image'
            : attachment.type.includes('video')
            ? 'fa-file-video'
            : 'fa-file-word'

          return (
            <div key={attachment.id} className='m-1'>
              <Button
                className='btn btn-sm btn-outline-primary'
                onClick={() => {
                  downloadAttachment({
                    key: attachment.key,
                    type: attachment.type,
                    url: '/activity/download-file',
                    name: attachment.name,
                    callback: (res) => {},
                  })
                }}
              >
                <i className={`fas ${icon}`} style={{ fontSize: '1.2rem', color: 'white' }} />
              </Button>
              <small className='ml-2'>{(attachment.name || '').slice(0, 10)}</small>
            </div>
          )
        })}
    </div>
  )
}

export default AttachmentList
